// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const ClientWrapper: StatelessFunctionalComponent<*> = styled.div`
  
  .Client {
    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;
    }
    
    @media (max-width: 700px){
      &-formRow {
        flex-direction: column;
      }
    }

    &-formRow-1 > * {
      margin: 0 10px;
    }
  }
`;

export default ClientWrapper;
